import Hedge from 'components/hedges/Hedge';
import WrapperEmptyState from 'components/layout/WrapperEmptyState';
import PageWrapper from 'components/utils/PageWrapper';
import HedgesContracts from 'pages/HedgesContracts';
import hedgesPlaceholder from '../images/hedges-unselected.png';

export const hedgeContractsRoutes = {
    path: '/hedges-contracts',
    element: (
        <PageWrapper titleId="hedges_and_contracts_title">
            <HedgesContracts />
        </PageWrapper>
    ),
    children: [
        {
            index: true,
            element: <WrapperEmptyState imgSrc={hedgesPlaceholder} page="Hedge" noun="configuration" />,
        },
        {
            path: ':hedgeId',
            element: <Hedge />,
        },
    ],
};
